import React, { useState } from 'react';

import { Flex, Box } from '../Rebass';
import Text from '../Text';
import { AnimatePresence, motion } from '../Motion';
import theme from '../../theme';
import Icon from '../Icon';
import styled from '@emotion/styled';

interface AccordionProps {
  headline: string;
  children: React.ReactNode;
  color?: string;
}

const StyledAccordian = styled(Box)<{ width: number[] }>`
  border-bottom: 1px solid ${theme.colors.baseGrayVeryLight};
`;

const StyledHeadline = styled(Flex)<{ isExpanded: boolean }>`
  cursor: pointer;

  i {
    font-size: 14px;
    transform: rotate(${({ isExpanded }) => (isExpanded ? '-90deg' : '90deg')});
    transition: transform ${theme.speed.default} linear;
  }
`;

const AnimatedChildren = motion.custom(styled(Box)`
  overflow: hidden;
`);

const Accordion = ({ headline, children, color }: AccordionProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <StyledAccordian width={[1]}>
      <StyledHeadline
        py={[3]}
        pr={[1]}
        justifyContent="space-between"
        alignItems="center"
        onClick={() => setIsExpanded(!isExpanded)}
        isExpanded={isExpanded}
      >
        <Text size="body" fontWeight="bold" fontFamily="serif" color={color}>
          {headline}
        </Text>
        <Icon
          name="chevron-right"
          sx={{
            transform: `rotate(${isExpanded ? 90 : 0}deg)`,
            transition: `transform ${theme.speed.default} ease`,
            color,
          }}
        />
      </StyledHeadline>
      <Box pb={[isExpanded ? 3 : 0]}>
        {/* @ts-ignore */}
        <AnimatePresence initial={false}>
          {isExpanded && (
            <AnimatedChildren
              key="accordion-content"
              variants={{
                open: { opacity: 1, height: 'auto' },
                closed: { opacity: 0, height: 0 },
              }}
              animate="open"
              initial="closed"
              exit="closed"
              transition={{ duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98] }}
            >
              {children}
            </AnimatedChildren>
          )}
        </AnimatePresence>
      </Box>
    </StyledAccordian>
  );
};

export default Accordion;
